import { shuffled } from "./collections";
import { DeterministicRandom, deriveSeed } from "./random";
import { DIRECTIONS, DIRECTION_COLORS } from "./types";
import type { DirectionColorMap, StageId } from "./types";

export function createDirectionColorMap(
  sessionSeed: number,
  stageId: StageId,
  trialIndex: number,
): DirectionColorMap {
  const random = new DeterministicRandom(
    deriveSeed(sessionSeed, `colors:${stageId}:${trialIndex}`),
  );
  const colors = shuffled(DIRECTION_COLORS, random);
  return Object.fromEntries(
    DIRECTIONS.map((direction, index) => [direction, colors[index]]),
  ) as Record<(typeof DIRECTIONS)[number], (typeof DIRECTION_COLORS)[number]>;
}
